
<template>
  <div>
    <dialog-loading v-if="loading"></dialog-loading>
    <v-dialog v-model="dialog" v-if="!loading" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          Fatura: {{ vrt_assigned_payments.comment }}
        </v-card-title>
        <v-card-text class="py-0" :style="vrt_assigned_payments.infos.length > 1 ? 'overflow-y: auto; height:60vh' : ''">
          <v-divider></v-divider>
          <div class="d-flex flex-column pt-2">

            <span>Data de vencimento: <b> {{$moment(vrt_assigned_payments.DateExpired).format('LL')}} </b></span>
            <span>Valor total da fatura: <b>{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(vrt_assigned_payments.ammount)  }}</b> </span>
            <span>Valor pago: <b>{{ new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(vrt_assigned_payments.ammount_payed) }}</b> </span>
            <span>ID do pedido: <b>#{{vrt_assigned_payments.external_order_id || vrt_assigned_payments.order_id}}</b> </span>
            <span>Metodo de pagamento da fatura: <b>{{vrt_assigned_payments.payment_description}}</b> </span>
            <span class="pt-3 mb-n3">Pagamentos relacionados a fatura: </span>
          </div>

          <div v-for="(item, idx) in vrt_assigned_payments.infos" :key="idx">
            <v-divider v-if="idx"></v-divider>
            <v-list dense >
              <!--  INFORMAÇÕES PAGAMENTO -->
              <v-subheader v-if="item.vrt_payment"><h3>Informações do pagamento {{idx + 1}}</h3></v-subheader>
              <v-list-item-group  v-if="item.vrt_payment" class="my-n1">
                <v-list-item >
                  <v-list-item-content>Status do pagamento <v-list-item-title> 
                    <v-chip x-small :class="['my-1', status_map[item.payment.status_id].color]" >{{status_map[item.payment.status_id].title}}</v-chip>
                  </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Valor do pagamento <v-list-item-title> R$ {{item.vrt_payment.paying_ammount}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item v-if="!['pix', 'bill'].includes(item.payment.kind)">
                  <v-list-item-content>Tipo do pagamento <v-list-item-title> {{payment_map[item.payment.kind]}} </v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <!--  INFORMAÇÕES PAGAMENTO -->
              
              <!-- INFORMAÇÕES BOLETO -->
              <v-subheader v-if="item.bill"><h3>Boleto</h3></v-subheader>
              <v-list-item-group v-if="item.bill">
                <v-list-item>
                  <v-list-item-content>Número do documento <v-list-item-title> {{item.bill.nf_number ? item.bill.nf_number : '-'}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Nosso número <v-list-item-title> {{item.bill.our_number ? item.bill.our_number : '-'}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Vencimento do boleto <v-list-item-title> {{$moment(item.bill.nf_due).format('LL')}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Status do boleto <v-list-item-title> 
                    {{ status_map[item.bill.status_id].title }} 
                  </v-list-item-title></v-list-item-content>
                </v-list-item>
                
                <v-list-item v-if="item.bill.canceled_at">
                  <v-list-item-content>Data de cancelamento <v-list-item-title> 
                    {{ $moment(item.bill.canceled_at).format('LL') }} 
                  </v-list-item-title></v-list-item-content>
                </v-list-item>
                
              </v-list-item-group>
              <!-- INFORMAÇÕES BOLETO -->
  
              <!-- INFORMAÇÕES PIX -->
              <v-subheader v-if="item.pix"><h3>Pix</h3></v-subheader>
              <v-list-item-group v-if="item.pix">
                <v-list-item>
                  <v-list-item-content>ID do pix <v-list-item-title> {{item.pix.id}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Chave <v-list-item-title> {{item.pix.company_key}} </v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>Status do pix <v-list-item-title> 
                    {{ pix_status_map[item.pix.pix_status] }} 
                  </v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <!-- INFORMAÇÕES PIX -->


              <!-- INFORMAÇÕES ENVELOPE -->
              <v-subheader v-if="item.envelope"><h3>Envelope</h3></v-subheader>
              <v-list-item-group v-if="item.envelope">
                <v-list-item>
                  <v-list-item-content>Código: <v-list-item-title> {{item.envelope.name}} </v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <!-- INFORMAÇÕES ENVELOPE -->

              <div v-if="item.pay_traces" v-for="(pay_trace, idx) in item.pay_traces" :key="idx">
                 <!-- INFORMAÇÕES ENVELOPE -->
                 <v-subheader v-if="item.pay_traces"><h3>Informações do pagamento {{idx + 1}}</h3></v-subheader>
                 <v-list-item-group >
                   <v-list-item>
                     <v-list-item-content>Compensação: <v-list-item-title> {{pay_trace.kind == 'manual' ? 'Manual' : 'Automática'}} </v-list-item-title></v-list-item-content>
                   </v-list-item>
                   <v-list-item>
                     <v-list-item-content>Valor: <v-list-item-title> 
                       {{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(pay_trace.value)  }} 
                     </v-list-item-title></v-list-item-content>
                   </v-list-item>
                   <v-divider></v-divider>
                 </v-list-item-group>
                 <!-- INFORMAÇÕES ENVELOPE -->
               </div>

            </v-list>
          </div>
          <h3 class="d-flex justify-center pb-6 pt-5" v-if="vrt_assigned_payments.infos.length == 0">Sem histórico</h3>

          <div v-for="(item, idx) in vrt_assigned_payments.infos" :key="idx">
            <v-list dense >
              <!-- INFORMAÇÕES ENVELOPE -->
              <v-subheader v-if="item.envelope"><h3>Envelope</h3></v-subheader>
              <v-list-item-group v-if="item.envelope">
                <v-list-item>
                  <v-list-item-content>Código: <v-list-item-title> {{item.envelope.name}} </v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list-item-group>
              <!-- INFORMAÇÕES ENVELOPE -->
            </v-list>
          </div>
          
          <v-divider></v-divider>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small class="error" @click="closeDialog()">fechar</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'AssignedVrtPaymentDialog',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  props: {
    selected_item: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      dialog: true,
      loading: true,
      vrt_assigned_payments: {
        infos: []
      },
      status_map: {
        2:  {title: "Inativo", color: 'error'},
        5:  {title: 'Cancelado', color: 'error'},
        6:  {title: "Aberto", color: 'primary'},
        7:  {title: "Pago", color: 'success'},
        11:  {title: "Computado", color: 'success'},
        16: {title: "Concluído", color: 'primary'}
      },
      pix_status_map: {
        "cancelled": 'Cancelado', 
        "expired": 'Expirado', 
        "pending": 'Pendente', 
        "error": 'Erro', 
        "approved": 'Aprovado'
      },
      payment_map: {
        "envelope": 'Envelope',
        "deposit": 'Depósito',
        "bill": 'Boleto',
        "bonus": 'Bonus',
        "pix": 'Pix'

      },
    }
  },
  methods: {
    closeDialog(){
      // this.dialog = false
      // this.vrt_assigned_payments = false
      this.$emit('closeDialog')
    },
    getItemInfos(id){
      this.loading = true
      
      Api.AssignedVrtPayment.show(id).then(r=> {
        this.vrt_assigned_payments = {
          ...JSON.parse(JSON.stringify(this.selected_item)), 
          infos: r.data
        }
      }).catch(err=>{
        console.log(err)
      }).finally(() =>{
        this.loading = false
      })
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getItemInfos(this.selected_item.id);
  },
}
</script>

<style scoped>

</style>